import { toTimestamp } from '../utils/addWebSocketToReplication'
import { toISOString, toISOStringOrNull } from '../utils/pushSafetyUtils'
import { createReplication } from './createReplication'
import type { LabelGroupCollection } from '../index'

export const setupLabelGroupReplication = (
  collection: LabelGroupCollection,
  envId: string,
) =>
  createReplication({
    entityName: 'labelgroups',
    displayName: 'LabelGroup',
    collection,
    envId,
    mapFromServer: (doc) => ({
      id: doc.id,
      envId: doc.envId,
      projectId: doc.projectId,
      name: doc.name,
      description: doc.description,
      sortOrder: doc.sortOrder,
      isDeleted: doc.isDeleted || false,
      createdOn: toTimestamp(doc.createdOn) ?? new Date(doc.createdOn).getTime(),
      createdBy: doc.createdBy,
      updatedOn: toTimestamp(doc.updatedOn) ?? new Date(doc.updatedOn).getTime(),
      updatedBy: doc.updatedBy,
      deletedOn: doc.deletedOn ? (toTimestamp(doc.deletedOn) ?? new Date(doc.deletedOn).getTime()) : null,
      deletedBy: doc.deletedBy,
    }),
    mapToServer: (state, envId) => ({
      id: state.id,
      envId,
      projectId: state.projectId,
      name: state.name,
      description: state.description,
      sortOrder: state.sortOrder,
      isDeleted: state.isDeleted,
      createdOn: toISOString(state.createdOn),
      createdBy: state.createdBy,
      updatedOn: toISOString(state.updatedOn),
      updatedBy: state.updatedBy,
      deletedOn: toISOStringOrNull(state.deletedOn),
      deletedBy: state.deletedBy,
    }),
  })
